<template>
    <div class="modal-body wrapper-lg" style="width:100%">
        <div class="row">
            <div class="col-sm-10" style="padding-left: 20px;">
                <form role="form" class="form-horizontal" style="margin-top: 20px" id="user_add_form">

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>培训项目编号</label>
                        <div class="col-sm-10">
                            <input type="text" v-model="model.xmbh" class="form-control" placeholder=""
                                   :readonly="true"/>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>培训项目名称</label>
                        <div class="col-sm-10">
                            <input type="text" v-model="model.pxzt" name="pxzt" v-validate="{required:true,max:50}"
                                   class="form-control" data-vv-as="培训主题" placeholder=""/>
                            <span class="error_validate_msg"><em>{{ errors.first('pxzt') }}</em></span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>项目分类</label>
                        <div class="col-sm-10">
                            <treeselect placeholder="-项目分类筛选-" v-model="model.lxId" :multiple="false"
                                        v-validate="{required:true}" data-vv-as="项目分类" name="lxId" :options="lxList"
                                        noChildrenText="无子类型" style="height: 31px;"/>
                            <span class="error_validate_msg"><em>{{ errors.first('lxId') }}</em></span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>培训对象</label>
                        <div class="col-sm-10">
                            <input type="text" v-model="model.pxdx" name="pxdx" v-validate="{required:true,max:50}"
                                   class="form-control" data-vv-as="培训对象" placeholder=""/>
                            <span class="error_validate_msg"><em>{{ errors.first('pxdx') }}</em></span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>培训开始时间</label>
                        <div class="col-sm-10">
							<DateTimePicker v-model="model.pxkssj" name="pxkssj" v-validate="{required:true}" data-vv-as="培训开始时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                            <div>
                                <span class="error_validate_msg"><em>{{ errors.first('pxkssj') }}</em></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>培训结束时间</label>
                        <div class="col-sm-10">
							<DateTimePicker v-model="model.pxjssj" name="pxjssj" v-validate="{required:true}" data-vv-as="培训结束时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                            <div>
                                <span class="error_validate_msg"><em>{{ errors.first('pxjssj') }}</em></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>集体报名开始时间</label>
                        <div class="col-sm-10">
							<DateTimePicker v-model="model.jtbmkssj" name="jtbmkssj" v-validate="{required:true}" data-vv-as="集体报名开始时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                            <div>
                                <span class="error_validate_msg"><em>{{ errors.first('jtbmkssj') }}</em></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>集体报名结束时间</label>
                        <div class="col-sm-10">
							<DateTimePicker v-model="model.jtbmjssj" name="jtbmjssj" v-validate="{required:true}" data-vv-as="集体报名结束时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                            <div>
                                <span class="error_validate_msg"><em>{{ errors.first('jtbmjssj') }}</em></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;">是否开放个人报名</label>
                        <div class="col-sm-10">
                            <select name="sfyxgrbm" id="sfyxgrbm" class="form-control" v-model="model.sfyxgrbm">
                                <option value="">-请选择-</option>
                                <option value="1">是</option>
                                <option value="0">否</option>
                            </select>
                        </div>
                    </div>

                 <div v-if="model.sfyxgrbm==1">
                     <div class="form-group">
                         <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>个人报名开始时间</label>
                         <div class="col-sm-10">
							 <DateTimePicker v-model="model.grbmkssj" name="grbmkssj" v-validate="{required:true}" data-vv-as="个人报名开始时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                 			<div>
                 			    <span class="error_validate_msg" ><em>{{ errors.first('grbmkssj') }}</em></span>
                 			</div>
                 		</div>
                     </div>
                 
                     <div class="form-group">
                         <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>个人报名结束时间</label>
                         <div class="col-sm-10">
							 <DateTimePicker v-model="model.grbmjssj" name="grbmjssj" v-validate="{required:true}" data-vv-as="个人报名结束时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                 			<div>
                 			    <span class="error_validate_msg" ><em>{{ errors.first('grbmjssj') }}</em></span>
                 			</div>
                 		</div>
                     </div>
                 </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>视频学习结束时间</label>
                        <div class="col-sm-10">
							<DateTimePicker v-model="model.spxxjssj" name="spxxjssj" v-validate="{required:true}" data-vv-as="视频学习结束时间" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:300px" :show-buttons="true" clearable></DateTimePicker>
                            <div>
                                <span class="error_validate_msg"><em>{{ errors.first('spxxjssj') }}</em></span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>培训费用</label>
                        <div class="col-sm-10">
                            <input type="text" v-model="model.pxfy" name="pxfy"
                                   v-validate="{required:true,numeric:true}" class="form-control" data-vv-as="培训费用"
                                   placeholder=""/>
                            <span class="error_validate_msg"><em>{{ errors.first('pxfy') }}</em></span>
                        </div>
                    </div>
                    <!--是否开启抓拍摄像-->
                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;">是否开启抓拍</label>
                        <div class="col-sm-4">
                            <select name="sfkqsxt" class="form-control" v-model="model.sfkqsxt">
                                <option value="">-请选择-</option>
                                <option value="1">是</option>
                                <option value="0">否</option>
                            </select>
                        </div>
                        <!--间隔时间-->
                        <label v-if="model.sfkqsxt==1" class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>抓拍间隔时间</label>
                        <div class="col-sm-4" v-if="model.sfkqsxt==1">
                            <input type="text" v-model="model.zpjgsj" class="form-control" placeholder="单位：秒" name="zpjgsj" v-validate="{required:true}" data-vv-as="抓拍间隔时间">
                            <span class="error_validate_msg"><em>{{ errors.first('zpjgsj') }}</em></span>
                        </div>
                    </div>
                    <!--是否开启人脸比对-->
                    <div v-if="model.sfkqsxt==1">
                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;">是否开启人脸比对</label>
                        <div class="col-sm-10">
                            <select name="sfkqrlbd" class="form-control" v-model="model.sfkqrlbd">
                                <option value="">-请选择-</option>
                                <option value="1">是</option>
                                <option value="0">否</option>
                            </select>
                        </div>
                    </div>
                    <!--比对阈值  比对间隔时间-->
                    <div class="form-group" v-if="model.sfkqrlbd==1">
                        <!--比对阈值-->
                        <label  class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>比对阈值</label>
                        <div class="col-sm-4" >
                            <input type="text" v-model="model.bdfz" class="form-control" placeholder="0-100 值越大则门槛越高" name="bdfz" v-validate="{required:true}" data-vv-as="比对阈值">
                            <span class="error_validate_msg"><em>{{ errors.first('bdfz') }}</em></span>
                        </div>
                        <!--比对间隔时间-->
                        <label  class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>比对间隔时间</label>
                        <div class="col-sm-4" >
                            <input type="text" v-model="model.bdjgsj" class="form-control" placeholder="单位：小时" name="bdjgsj" v-validate="{required:true}" data-vv-as="比对间隔时间">
                            <span class="error_validate_msg"><em>{{ errors.first('bdjgsj') }}</em></span>
                        </div>
                    </div>
                    </div>
                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>状态</label>
                        <div class="col-sm-10">
                            <select name="zt" class="form-control" v-model="model.zt" data-vv-as="状态">
                                <option value="">-请选择-</option>
                                <option value="OK">启用</option>
                                <option value="BLOCK">禁用</option>
                            </select>
                            <span class="error_validate_msg"><em>{{ errors.first('zt') }}</em></span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;"><span class="required">*</span>是否开放课件学习弹题</label>
                        <div class="col-sm-10">
                            <select name="kftt" v-model="model.kftt" v-validate="{required:true}"
                                    data-vv-as="是否开放课件学习弹题" class="form-control">
                                <option value="">-请选择-</option>
                                <option value="1">是</option>
                                <option value="0">否</option>
                            </select>
                            <span class="error_validate_msg"><em>{{ errors.first('kftt') }}</em></span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;">宣传图(234*234)</label>
                        <div class="col-sm-10">
                            <image-upload v-model="model.xct" width="117px" height="117px"></image-upload>
                        </div>
                    </div>
                    <div class="form-group" v-if="loaded">
                        <label class="col-sm-2 control-label" style="padding-left: 0px;">培训通知</label>
                        <div class="col-sm-10">
                            <ck-editor id="ck_pxzt_editor" v-model="model.pxtz" height="200px"></ck-editor>
                        </div>
                    </div>
                    <div>
                        <center>
                            <button class="btn btn-primary" type="button" @click="save()">保存</button>
                            <button style="margin-left:10px" class="btn btn-default" type="button" @click="cancel()">
                                取消
                            </button>
                        </center>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

    /**
     * 培训批次设置-新增培训批次
     */
    //时间插件引入
    export default {
        name: 'TrainingBatchConfigEdit',
        data: function () {
            return {
                lxList: [],
                loaded: false,
                model: {
                    id: this.$route.query.id,
                    xmbh: '',
                    pxzt: '',//培训主题
                    pxkssj: '',
                    pxjssj: '',
                    xct: '',
                    pxtz: '',
                    lxId: null,
                    pxdx: '',
                    jtbmkssj: '',//集体报名开始时间
                    jtbmjssj: '',//集体报名结束时间
                    sfyxgrbm: '',//是否开放个人报名
                    grbmkssj: '',//个人报名开始时间
                    grbmjssj: '',//个人报名结束时间
                    spxxjssj: '',//视频学习结束时间
                    kftt: '',//是否开放弹题
                    zt: '',//状态
                    pxfy: '',
                    //  增加参数
                    sfkqsxt: '0',//是否开启抓拍摄像 默认否
                    zpjgsj: '', //抓拍间隔时间
                    sfkqrlbd: '0',//是否开启人脸比对 默认否
                    bdjgsj: '',//比对间隔时间
                    bdfz: '',//比对阈值
                }
            }
        },
        created: function () {
            this.$store.commit('setBreadcrumb', [{name: '职业培训'}, {name: '在线培训'}, {name: '培训项目管理'}, {name: '编辑培训项目'}]);
            this.$store.commit('setShowReturnBackBtn',true);
            this.$http.post('/htgl/biz/pxjh/pc/getLxTree').then(res => {
                if (res.data) {
                    this.lxList = res.data;
                }
            });
            this.$http.post('/htgl/biz/pxjh/pc/xq', {id: this.model.id}).then(res => {
                this.loaded = true;
                if (res.data) {
                    this.model = res.data;
                }
            });
        },
        methods: {
            save: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/biz/pxjh/pc/xg', this.model).then(res => {
                            console.log(this.model)
                            if (res.data == true) {
                                this.$success('操作成功', () => {
                                    this.$router.push({name: 'TrainingBatchConfigList'})
                                })
                            }
                        })
                    }
                })
            },
            cancel: function () {
                this.$router.push({name: 'TrainingBatchConfigList'});
            }
        }

    }
</script>
